export const createState = () => ({
  isLogin: false,
  userName: '',
  avatarURL: '',
  toast: null,
  toastOptions: {},
  preRequests: {},
});

export default createState();
